import React from "react";

import Error404 from "../../error/Error404";

function Form() {
  return (
    <div>
      <Error404 />
    </div>
  );
}

export default Form;
